import { Box, Typography } from '@mui/material'
import { FeatureFlagIdInventoryAlerts } from 'c1gen/features'
import { C1IconButton } from 'c1ui'
import { C1Icon } from 'components/core/icons/C1Icon'
import { useFeatureChecker } from 'components/no-ui/capability'
import { InventoryAlertsDrawer } from 'components/pages/explore/inventory/InventoryAlertsDrawer'
import { useDrawer } from 'hooks/useDrawer'
import { BellRing } from 'lucide-react'
import { ReactElement } from 'react'
import { useIntl } from 'react-intl'

type InventoryAlertNotificationProps = {
    alertCount: number
    appResourceId?: string
    appId: string
    appUserId?: string
    appResourceTypeId?: string
}

export const InventoryAlertNotification = ({
    alertCount, appResourceId, appId, appUserId, appResourceTypeId,
}: InventoryAlertNotificationProps): ReactElement | null => {
    const hasInventoryAlertsFF = useFeatureChecker(FeatureFlagIdInventoryAlerts)
    const [showDrawer, closeDrawer] = useDrawer()
    const hasAlertCount = alertCount && alertCount > 0
    const intl = useIntl()
    if (!hasInventoryAlertsFF || !hasAlertCount) {
        return null
    }
    const showAlertsDrawer = (): void => {
        showDrawer(<InventoryAlertsDrawer
            appId={appId}
            appUserId={appUserId}
            appResourceId={appResourceId}
            appResourceTypeId={appResourceTypeId}
            closeDrawer={closeDrawer}
        />)
    }
    return <Box display="flex" alignItems="center">
        <C1IconButton
            variant="outlined"
            onClick={showAlertsDrawer}
            sx={{ borderColor: 'border.emphasis' }}
            aria-label={intl.formatMessage({
                id: 'components_inventory_alert_notification_open_drawer',
                defaultMessage: 'Open alerts drawer',
            })}
        >
            <>
                <C1Icon icon={BellRing} sx={{ color: 'warning.main' }} />
                <Typography pl={1}>{alertCount}</Typography>
            </>
        </C1IconButton>
    </Box>
}
